import { ColumnDef } from "@tanstack/react-table";
import { LineClampedTooltip } from "@/core/components/line-clamped-tooltip";

type ReviewBodyRow = {
  body: string | null;
};

export const ReviewBodyCol = <
  T extends ReviewBodyRow = ReviewBodyRow,
>(): ColumnDef<T> => ({
  header: "Review",
  accessorFn: (row) => (row.body || "").trim().toLowerCase(),
  accessorKey: "body",
  sortingFn: "alphanumeric",
  cell: ({ row }) => {
    const body = row.original.body;
    if (!body) return "—";
    return <LineClampedTooltip>{body}</LineClampedTooltip>;
  },
});
